<template>
  <div class="common-home-content" :class="is_app?'':'common-home-content-pt'" v-show="show">
    <div class="home-header" v-if="!is_app">
      <button class="page-back" @click="pageback">
        <span></span>
      </button>
      <span class="title">收货地址</span>
      <button class="header-right-btn"  v-if="addressData.length > 0" @click="handelDelete">{{delete_title}}</button>
    </div>
    <div class="space_pl space_pr" v-if="addressData.length > 0">
      <ul class="address-ul">
        <li
          :class="deletestatus?'delete-status':''"
          v-for="(child, index) in addressData"
          :key="index"
          @click="handleSelect(child, index)"
        >
          <span class="select" :class="child.selected?'selected':''" v-if="deletestatus"></span>
          <p class="info">
            <span class="name">{{child.nickname}}</span>
            <span class="phone">{{child.phone}}</span>
            <span class="defalut" v-if="child.is_default == 2">默认</span>
            <span class="mark" v-if="child.tag_name">{{child.tag_name}}</span>
          </p>
          <p class="area">{{getArea(child.area)}}&nbsp;{{child.address}}</p>
          <button class="edit-btn" @click.stop="toEdit(child)"></button>
        </li>
      </ul>
    </div>
    <div class="not-address" v-else>
      <img src="../../assets/images/address/tip.png" alt />
      <p class="title">您还没有收货地址哦~</p>
    </div>
    <div class="fixed-btns clearfix" v-if="deletestatus">
      <div class="fl select-all" @click="handleSelectAll">
        <span class="all" :class="select_arr.length == addressData.length?'selected':''"></span>全选
      </div>
      <button class="fr btn" :class="select_arr.length > 0?'btn-selected':''" @click="toDelete">删除</button>
    </div>
    <div class="fixed-btns2" v-else>
      <button @click="toEdit(false)">新建收货地址</button>
    </div>
    <van-popup v-model="popup_show" :close-on-click-overlay="false">
      <div class="popup-window">
        <p class="title">是否删除该地址</p>
        <div class="btns clearfix">
          <button class="fl left" @click="handleClosePopup">取消</button>
          <button class="fr right" @click="handleConfirmDelete">删除</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { deviceType } from "../../util/deviceType";
import http from "../../util/gaeaApiConfig";
export default {
  data() {
    return {
      show: false,
      addressData: [],
      select_arr: [],
      delete_title: "批量删除",
      user_id: 1,
      deletestatus: false,
      popup_show: false,
      token: "",
      is_app: deviceType.isApp,
        platform_type: 1,

    };
  },
  created() {
    let bridge = window.WebViewJavascriptBridge;
    this.isApp = this.$appUtils.isApp();
    if(this.isApp == "IOS"){
      bridge.callHandler("getUserInfo", "", (response) => {
        this.user_id = response.user_id
        this.token = response.token
        this.platform_type = response.platform_type
      });
      bridge.callHandler('showTrBtn',{ name: this.delete_title },(response)=>{

      })
      bridge.registerHandler('appTrBtnClick',(data,response)=>{
        this.handelDelete();
      })
    }else if(this.isApp == 'android'){
      this.$appUtils.showAppTrBtn({ name: this.delete_title });
      var user_info = this.$appUtils.appData();
      if (user_info) {
        this.user_id = user_info.user_id;
        this.token = user_info.token;
        this.platform_type = user_info.platform_type;
      }
    }else{
      this.user_id = this.$route.query.user_id
      this.token = this.$route.query.token
      this.platform_type = 1
    }
    setTimeout(()=>{
      this.getDate();
    },500)
    window.appTrBtnClick = () => this.handelDelete();
    window.appBack = () => this.pageback();
  },
  destroyed() {
    let bridge = window.WebViewJavascriptBridge;
    this.isApp = this.$appUtils.isApp();
    if(this.isApp == "IOS"){
      bridge.callHandler('showTrBtn',{ name: '' },(response)=>{
      })
    }else if(this.isApp == 'android'){
      this.$appUtils.showAppTrBtn({ name: '' });
    }
  },
  methods: {
    getArea(arr) {
      let str = "";
      if (arr) {
        arr = JSON.parse(arr);
        for (let i = 0; i < arr.length; i++) {
          if (i == 0) {
            str = arr[i]["name"];
          } else {
            str = str + " " + arr[i]["name"];
          }
        }
      }
      return str;
    },
    getDate() {
      let that = this;
      http
        .get("/users/" + that.user_id + "/addresses"+'?platform_type=' +this.platform_type, {
          headers: {
            Authorization: that.token,
          },
        })
        .then(function (res) {
          that.addressData = res.data.data.addresses;
          that.show = true;
          that.getSelected();
          that.$forceUpdate();
        });
    },
    getSelected() {
      let that = this;
      that.select_arr = [];
      for (let i = 0; i < that.addressData.length; i++) {
        if (that.addressData[i]["selected"]) {
          that.select_arr.push(that.addressData[i]["address_id"]);
        }
      }
    },
    handelDelete() {
      this.deletestatus = !this.deletestatus;
      if (this.deletestatus) {
        this.delete_title = "取消";
        let bridge = window.WebViewJavascriptBridge;
        this.isApp = this.$appUtils.isApp();
        if(this.isApp == "IOS"){
          bridge.callHandler('showTrBtn',{ name:  this.delete_title },(response)=>{
          })
        }else if(this.isApp == 'android'){
          this.$appUtils.showAppTrBtn({ name: this.delete_title });
        }

      } else {
        this.delete_title = "批量删除";
        let bridge = window.WebViewJavascriptBridge;
        this.isApp = this.$appUtils.isApp();
        if(this.isApp == "IOS"){
          bridge.callHandler('showTrBtn',{ name:  this.delete_title },(response)=>{
          })
        }else if(this.isApp == 'android'){
          this.$appUtils.showAppTrBtn({ name: this.delete_title });
        }
        for (let i = 0; i < this.addressData.length; i++) {
          this.addressData[i]["selected"] = false;
        }
      }
    },
    handleSelect(item, index) {
      console.log(this.deletestatus)
      if (this.deletestatus) {
        item["selected"] = !item["selected"];
        this.getSelected();
      } else {
        localStorage.removeItem("address_id");
          localStorage.setItem("address_id", item["address_id"]);
        if (this.is_app) {
          this.pageback();
        } else {
          this.$router.go(-1);
        }
      }
    },
    handleSelectAll() {
      let that = this;
      if (that.select_arr.length == that.addressData.length) {
        for (let i = 0; i < this.addressData.length; i++) {
          this.addressData[i]["selected"] = false;
        }
      } else {
        for (let i = 0; i < this.addressData.length; i++) {
          this.addressData[i]["selected"] = true;
        }
      }
      that.getSelected();
      that.$forceUpdate();
    },
    toDelete() {
      let that = this;
      if (that.select_arr.length > 0) {
        this.popup_show = true;
      }
    },
    handleClosePopup() {
      this.popup_show = false;
    },
    handleConfirmDelete() {
      let that = this;
      let params = {
        address_ids: that.select_arr.join(","),
      };
      http
        .delete(
          "/users/" + that.user_id + "/addresses"+'?platform_type=' +this.platform_type,
          { params: params,   headers: { Authorization: that.token } },

        )
        .then(function (res) {
          if (res.data.status_code == 200) {
            that.getDate();
            that.popup_show = false;
          }
        });
    },
    toEdit(item) {
      if (item) {
        this.$router.push({
          path: "/address",
          query: { address_id: item["address_id"] },
        });
      } else {
        this.$router.push({ path: "/address" });
      }
    },
    pageback() {
      if (this.$route.query.t) {
        window.history.back();
        return true;
      } else {
        return null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.common-home-content {
  padding-bottom: 59px;
}
.common-home-content-pt {
  padding-top: 50px;
}
.header-right-btn {
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color:#AC4B38;
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 15px;
}
.not-address {
  margin-top: 218px;
  width: 100%;
  display: inline-block;
  text-align: center;
  img {
    width: 118px;
  }
  .title {
    margin-top: 17px;
    line-height: 16px;
    font-size: 16px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    color: rgba(154, 154, 154, 1);
  }
}
.address-ul {
  width: 100%;
  box-sizing: border-box;
  padding-top: 15px;
  & > li {
    width: 100%;
    box-sizing: border-box;
    padding: 15px 50px 14px 0;
    border-bottom: 1px solid #e6e6e6;
    position: relative;
    .info {
      line-height: 16px;
      .name {
        font-size: 16px;
        font-family: PingFang-SC-Bold;
        font-weight: bold;
        color: rgba(52, 52, 52, 1);
      }
      .phone {
        margin-left: 17px;
        font-size: 15px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: rgba(154, 154, 154, 1);
      }
      .defalut {
        margin-left: 10px;
        display: inline-block;
        width: 29px;
        line-height: 16px;
        font-size: 10px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        text-align: center;
        color: rgba(255, 255, 255, 1);
        background-color: rgba(172, 76, 56, 1);
        border-radius: 5px;
      }
      .mark {
        margin-left: 5px;
        display: inline-block;
        width: 27px;
        line-height: 14px;
        font-size: 10px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: rgba(172, 76, 56, 1);
        text-align: center;
        border: 1px solid rgba(172, 76, 56, 1);
        border-radius: 4px;
      }
    }
    .area {
      margin-top: 8px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: rgba(52, 52, 52, 1);
      line-height: 18px;
    }
    .edit-btn {
      display: block;
      width: 17px;
      height: 17px;
      background: url("../../assets/images/address/edit.png") no-repeat;
      background: none\9;
      filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../../assets/images/address/edit.png',sizingMethod='scale');
      -webkit-background-size: 17px 17px;
      -moz-background-size: 17px 17px;
      background-size: 17px 17px;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
    }
  }
  .delete-status {
    padding-left: 49px;
    padding-right: 46px;
    .select {
      display: block;
      width: 18px;
      height: 18px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);
      border: 1px solid#cccccc;
      border-radius: 50%;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
    }
    .selected {
      border: none;
      background: url("../../assets/images/address/selected.png") no-repeat;
      background: none\9;
      filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../../assets/images/selected/edit.png',sizingMethod='scale');
      -webkit-background-size: 18px 18px;
      -moz-background-size: 18px 18px;
      background-size: 18px 18px;
    }
  }
}
.fixed-btns {
  width: 100%;
  box-sizing: border-box;
  padding: 7px 15px;
  border-top: 1px solid #e6e6e6;
  position: fixed;
  left: 0;
  bottom: 0;
  .select-all {
    display: inline-block;
    box-sizing: border-box;
    padding-left: 28px;
    line-height: 36px;
    font-size: 17px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(52, 52, 52, 1);
    position: relative;
    .all {
      display: block;
      width: 18px;
      height: 18px;
      box-sizing: border-box;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #cccccc;
      border-radius: 50%;
      margin: auto;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
    }
    .selected {
      border: none;
      background: url("../../assets/images/address/selected.png") no-repeat;
      background: none\9;
      filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../../assets/images/selected/edit.png',sizingMethod='scale');
      -webkit-background-size: 18px 18px;
      -moz-background-size: 18px 18px;
      background-size: 18px 18px;
    }
  }
  .btn {
    display: inline-block;
    width: 74px;
    line-height: 36px;
    font-size: 17px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    background-color: #cccccc;
    border-radius: 4px;
  }
  .btn-selected {
    background-color: rgba(172, 76, 56, 1);
  }
}
.fixed-btns2 {
  width: 100%;
  box-sizing: border-box;
  padding: 3px 15px;
  position: fixed;
  left: 0;
  bottom: 0;
  & > button {
    display: block;
    width: 100%;
    box-sizing: border-box;
    line-height: 43px;
    font-size: 17px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    background: rgba(172, 76, 56, 1);
    border-radius: 4px;
  }
}
.popup-window {
  width: 300px;
  box-sizing: border-box;
  padding: 35px 25px 27px 25px;
  .title {
    line-height: 17px;
    font-size: 17px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    text-align: center;
    color: rgba(52, 52, 52, 1);
  }
  .btns {
    margin-top: 42px;
    width: 100%;
    box-sizing: border-box;
    .left {
      width: 120px;
      line-height: 30px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: rgba(172, 76, 56, 1);
      text-align: center;
      border: 1px solid rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
    .right {
      width: 120px;
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #fff;
      text-align: center;
      background-color: rgba(172, 76, 56, 1);
      border-radius: 4px;
    }
  }
}
.van-popup {
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/address/addresslist.vue